import { render, staticRenderFns } from "./setupA2p.vue?vue&type=template&id=0eeafd36"
import script from "./setupA2p.vue?vue&type=script&lang=js"
export * from "./setupA2p.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports